module.exports = __webpack_public_path__ + "static/ggbs-a7ab66b30a740f1c3448ca64b1108ddf.svg";